import { jsxs, jsx } from 'react/jsx-runtime';
import { IconXSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';

const Tag = ({ variant, className, children, onRemoveClick, locale = {
    remove: 'Remove'
}, ...props })=>{
    return jsxs("span", {
        className: classNames('cb-tag', `cb-tag-${variant}`, className),
        ...props,
        children: [
            children,
            onRemoveClick && jsx("button", {
                "aria-label": locale.remove,
                onClick: onRemoveClick,
                type: "button",
                children: jsx(IconXSolid, {
                    size: 16
                })
            })
        ]
    });
};
Tag.displayName = 'Tag';

export { Tag, Tag as default };
//# sourceMappingURL=Tag.es.js.map
